import {eventSlots,parseSetupKey,resolveSetupEvent,setupKey} from '../../utils/eventSetup';
import {activeReviewItem} from '../../utils/resourceReview';
export function recordWorkspaceRoute({teamId,team,record,kind='vod',mapId,contextSearch=''}){
  if(!activeReviewItem(record)||!record.calendarEventId)return null;
  const parsed=parseSetupKey(record.calendarEventId);
  if(parsed&&parsed.scope!=='team')return null;
  const event=resolveSetupEvent(team.events||[],record.calendarEventId);
  if(!event||(!parsed&&event.repeat&&event.repeat!=='none'))return null;
  const slot=eventSlots(event).find(slot=>parsed?slot.id===parsed.slotId:kind==='stats'?slot.statsId===record.id:slot.mapId===mapId&&slot.matchId===record.matchId);
  if(!slot||(kind==='vod'&&(!record.matchId||slot.matchId!==record.matchId||slot.mapId!==mapId))||(kind==='stats'&&slot.statsId!==record.id))return null;
  const params=new URLSearchParams({calendarTeam:teamId,eventWorkspace:setupKey(event,slot.id),eventTab:kind==='stats'?'stats':'vod'});
  const context=new URLSearchParams(contextSearch);
  for(const key of ['focus','anchor','noteId','replyId','t','time','timestamp'])if(context.has(key))params.set(key,context.get(key));
  if(kind==='vod')params.set('eventVideo',record.id);
  return '/library?'+params;
}
